import React, { useState } from 'react'
import { useFormatMessage } from '@babylon/intl'

import DataPoints from '../../components/DataPoints'
import Scores from '../../components/Scores'
import SidePanel from '../../components/SidePanel'
import useAssessmentFilterFeatureFlags from '../../utils/useAssessmentFilterFeatureFlags'
import DataPointsFilter from '../../components/DataPointsFilter'
import { FlowInterface } from '../../types'
import filterMessages from '../../components/DataPointsFilter/messages'

const FlowPanel = ({ flow, onClose }: Props) => {
  const fm = useFormatMessage()
  const {
    assessmentYesFilterEnabled,
    assessmentNotApplicableFilterEnabled,
  } = useAssessmentFilterFeatureFlags()
  const [highlightYesAnswers, setHighlightYesAnswers] = useState(false)
  const [hideNotApplicableAnswers, setHideNotApplicableAnswers] = useState(
    false
  )

  return (
    <SidePanel onClose={onClose} title={flow.name}>
      {assessmentYesFilterEnabled && (
        <DataPointsFilter
          onClick={() => setHighlightYesAnswers(!highlightYesAnswers)}
          checked={highlightYesAnswers}
          label={fm(filterMessages.yesAnswersFilter)}
        />
      )}

      {assessmentNotApplicableFilterEnabled && (
        <DataPointsFilter
          onClick={() => setHideNotApplicableAnswers(!hideNotApplicableAnswers)}
          checked={hideNotApplicableAnswers}
          label={fm(filterMessages.notApplicableAnswersFilter)}
        />
      )}

      <DataPoints
        flow={flow}
        highlightYesAnswers={highlightYesAnswers}
        hideNotApplicableAnswers={hideNotApplicableAnswers}
      />
      <Scores scores={flow.scores} />
    </SidePanel>
  )
}

interface Props {
  flow: FlowInterface
  onClose: () => void
}

export default FlowPanel
